module.exports = __webpack_public_path__ + "static/media/controller.33e9e5c6.svg";